export enum ACCOUNT_TYPE {
  DEPOSIT = 'deposit',
  IRA = 'ira',
  INVEST = 'invest',
}

export const MAX_NON_IRA_BENES = 10
export const MAX_IRA_BENES = 6

export const SPECIAL_CHAR = /^([a-zA-Z0-9 .\-'])+$/

export const STATES = [
  { ID: 'AA', DESCRIPTION: 'Armed Forces America' },
  { ID: 'AE', DESCRIPTION: 'Armed Forces Europe' },
  { ID: 'AK', DESCRIPTION: 'Alaska' },
  { ID: 'AL', DESCRIPTION: 'Alabama' },
  { ID: 'AP', DESCRIPTION: 'Armed Forces Pacific' },
  { ID: 'AR', DESCRIPTION: 'Arkansas' },
  { ID: 'AS', DESCRIPTION: 'American Samoa' },
  { ID: 'AZ', DESCRIPTION: 'Arizona' },
  { ID: 'CA', DESCRIPTION: 'California' },
  { ID: 'CO', DESCRIPTION: 'Colorado' },
  { ID: 'CT', DESCRIPTION: 'Connecticut' },
  { ID: 'DC', DESCRIPTION: 'District of Columbia' },
  { ID: 'DE', DESCRIPTION: 'Delaware' },
  { ID: 'FL', DESCRIPTION: 'Florida' },
  { ID: 'FM', DESCRIPTION: 'Federated States of Micronesia' },
  { ID: 'GA', DESCRIPTION: 'Georgia' },
  { ID: 'GU', DESCRIPTION: 'Guam' },
  { ID: 'HI', DESCRIPTION: 'Hawaii' },
  { ID: 'IA', DESCRIPTION: 'Iowa' },
  { ID: 'ID', DESCRIPTION: 'Idaho' },
  { ID: 'IL', DESCRIPTION: 'Illinois' },
  { ID: 'IN', DESCRIPTION: 'Indiana' },
  { ID: 'KS', DESCRIPTION: 'Kansas' },
  { ID: 'KY', DESCRIPTION: 'Kentucky' },
  { ID: 'LA', DESCRIPTION: 'Louisiana' },
  { ID: 'MA', DESCRIPTION: 'Massachusetts' },
  { ID: 'MD', DESCRIPTION: 'Maryland' },
  { ID: 'ME', DESCRIPTION: 'Maine' },
  { ID: 'MH', DESCRIPTION: 'Marshall Islands' },
  { ID: 'MI', DESCRIPTION: 'Michigan' },
  { ID: 'MN', DESCRIPTION: 'Minnesota' },
  { ID: 'MO', DESCRIPTION: 'Missouri' },
  { ID: 'MP', DESCRIPTION: 'Northern Mariana Islands' },
  { ID: 'MS', DESCRIPTION: 'Mississippi' },
  { ID: 'MT', DESCRIPTION: 'Montana' },
  { ID: 'NC', DESCRIPTION: 'North Carolina' },
  { ID: 'ND', DESCRIPTION: 'North Dakota' },
  { ID: 'NE', DESCRIPTION: 'Nebraska' },
  { ID: 'NH', DESCRIPTION: 'New Hampshire' },
  { ID: 'NJ', DESCRIPTION: 'New Jersey' },
  { ID: 'NM', DESCRIPTION: 'New Mexico' },
  { ID: 'NV', DESCRIPTION: 'Nevada' },
  { ID: 'NY', DESCRIPTION: 'New York' },
  { ID: 'OH', DESCRIPTION: 'Ohio' },
  { ID: 'OK', DESCRIPTION: 'Oklahoma' },
  { ID: 'OR', DESCRIPTION: 'Oregon' },
  { ID: 'PA', DESCRIPTION: 'Pennsylvania' },
  { ID: 'PR', DESCRIPTION: 'Puerto Rico' },
  { ID: 'PW', DESCRIPTION: 'Palau' },
  { ID: 'RI', DESCRIPTION: 'Rhode Island' },
  { ID: 'SC', DESCRIPTION: 'South Carolina' },
  { ID: 'SD', DESCRIPTION: 'South Dakota' },
  { ID: 'TN', DESCRIPTION: 'Tennessee' },
  { ID: 'TX', DESCRIPTION: 'Texas' },
  { ID: 'UT', DESCRIPTION: 'Utah' },
  { ID: 'VA', DESCRIPTION: 'Virginia' },
  { ID: 'VI', DESCRIPTION: 'Virgin Islands' },
  { ID: 'VT', DESCRIPTION: 'Vermont' },
  { ID: 'WA', DESCRIPTION: 'Washington' },
  { ID: 'WI', DESCRIPTION: 'Wisconsin' },
  { ID: 'WV', DESCRIPTION: 'West Virginia' },
  { ID: 'WY', DESCRIPTION: 'Wyoming' },
]

export const BENEFICIARY_CLASSIFICATION = {
  individual: 'Individual',
  charity: 'Non-profit or charity',
  trust: 'Trust',
  other: 'Other',
}

export const BENEFICIARY_CLASSIFICATION_CODES: { [key: string]: string } = {
  individual: 'I',
  charity: 'NC',
  trust: 'T',
  other: 'O',
}

export enum API_STATUS {
  IDLE = 'IDLE',
  PENDING = 'PENDING',
  RESOLVED = 'RESOLVED',
  REJECTED = 'REJECTED',
  UPDATING = 'UPDATING',
}

export enum CLASSIFICATION_CODES {
  I = 'Individual',
  NC = 'Non-profit or charity',
  T = 'Trust',
  O = 'Other',
}

export enum IDENTIFIER_NAMES {
  DrLicense = 'DriversLicense',
  AlienIDCard = 'AlienIdentificationCard',
  Passport = 'ValidPassport',
  Military = 'MilitaryId',
}

export const ADDRESS_VALIDATION_MESSAGES = {
  validAddress: 'Enter a valid address.',
  specialChar:
    'Your address can’t contain & < > “ / ~ | ^ ? @ ! ` $ % * ( ) _ = + { } [ ] ;',
  poBox: 'Enter an address that is not a P.O. Box',
}

export const CITY_VALIDATION_MESSAGES = {
  validCity: 'Enter a valid city.',
  specialChar:
    'Your city can’t contain # & < > “ / ~ | ^ ? @ ! ` $ % * ( ) _ = + { } [ ] ; : ,',
}

export const STATE_VALIDATION_MESSAGES = {
  validState: 'Enter a valid state.',
}

export const ZIP_CODE_VALIDATION_MESSAGES = {
  validZipCode: 'Enter a valid ZIP code.',
}

export const RELATIONSHIP_OPTIONS = [
  {
    label: 'Child',
    value: 'child',
  },
  {
    label: 'Legal Guardian',
    value: 'legalGuardian',
  },
  {
    label: 'Parent',
    value: 'parent',
  },
  {
    label: 'Spouse',
    value: 'spouse',
  },

  {
    label: 'Other',
    value: 'other',
  },
]

export const GENERIC_ERROR_MESSAGE = `We couldn't process your request. Please contact Customer Service at 1-877-247-2559.`
export const ZIP_CODE_ERROR = `The ZIP code doesn't match the state you entered. Please check your information and try again.`
export const RELATIONSHIP_OPTIONS_NO_SPOUSE = [
  {
    label: 'Child',
    value: 'child',
  },
  {
    label: 'Legal Guardian',
    value: 'legalGuardian',
  },
  {
    label: 'Parent',
    value: 'parent',
  },
  {
    label: 'Other',
    value: 'other',
  },
]
